import { PieChart as PieChartIcon } from 'lucide-react'
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts'

import type { SeriesItem } from '@/types/api/dashboard'

interface DonutChartWidgetProps {
  title: string
  data?: SeriesItem[]
  showValuesOnHover?: boolean
}

const COLORS = ['#10b981', '#ef4444', '#f59e0b', '#6366f1', '#8b5cf6', '#06b6d4', '#ec4899', '#84cc16']

export function DonutChartWidget({ title, data = [], showValuesOnHover = true }: DonutChartWidgetProps) {
  const chartData = data.map((item) => ({ name: item.label, value: Number(item.value) }))
  return (
    <div className="flex h-full flex-col">
      <div className="mx-4 mt-4 flex items-center gap-2">
        <div className="flex h-5 w-5 items-center justify-center rounded bg-gradient-to-br from-purple-500 to-violet-500 text-white">
          <PieChartIcon className="h-3 w-3" />
        </div>
        <p className="text-xs font-semibold uppercase tracking-wider text-neutral-500">{title}</p>
      </div>
      <div className="flex-1 px-2 pb-2">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={chartData} dataKey="value" nameKey="name" innerRadius={55} outerRadius={80}>
              {chartData.map((entry, index) => (
                <Cell key={`${entry.name}-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            {showValuesOnHover ? (
              <Tooltip
                formatter={(value, name) => [String(value ?? ''), String(name ?? '')]}
                contentStyle={{
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  border: '1px solid #e5e5e5',
                  borderRadius: '8px',
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.05)',
                }}
              />
            ) : null}
            <Legend iconType="circle" wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
